import { Paper } from "@mui/material"
import { PagedRepeat } from "lib/@components/paged-repeat"

import { ReportRow } from "routes/sfg20-admin/plugins/system-info/reports-tab/report-row"
import { ReportHeader } from "routes/sfg20-admin/plugins/system-info/reports-tab/report-header"
import { DownloadButton } from "routes/sfg20-admin/plugins/system-info/common/components/download-button"

export function Report({ data, columns, title }) {
    if (!data) {
        return null
    }
    return (
        <Paper sx={{ padding: 2 }}>
            <ReportHeader columns={columns} />
            <PagedRepeat list={data.value} item={<ReportRow columns={columns} />} />
            <DownloadButton data={data} title={title} columns={columns} />
        </Paper>
    )
}
